<template>
  <div class="page">
    <side-icons />
    <section class="section">
      <div class="text-center"><h3 class="fs-36 text-decoration section-title">Ph.D. Thesis</h3></div>
      <div class="list">
        <div class="item">
          <p class="title">Études de modèles variationnels et apprentissage de dictionnaires</p>
          <div class="margin-top-20px text">
            <i class="iconfont icon-zazhiqikan" />
            <span>Université Paris Nord, Oct 2007</span>
          </div>
        </div>
      </div>
    </section>
    <section class="section">
      <div class="text-center"><h3 class="fs-36 text-decoration section-title">Patent</h3></div>
      <div class="list">
        <div class="item">
          <p class="title">An initialization method of structure matrix compression neural network for weight sharing</p>
          <div class="margin-top-20px text">
            <p class="icon-text">
              <i class="iconfont icon-renyuan" />
              <span class="margin-right-20px"><b>Tieyong Zeng</b>, Xiaofeng Ding, Hongfei Yang, and Hui Hu</span>
            </p>
            <p class="icon-text">
              <i class="iconfont icon-zazhiqikan" />
              <span>PCT/CN2019/084969</span>
            </p>
          </div>
        </div>
      </div>
    </section>
    <section id="journal" class="section">
      <div class="text-center"><h3 class="fs-36 text-decoration section-title">Journal Papers</h3></div>
      <div class="list">
        <div v-for="(item, index) in journalPageList" :key="index" class="item">
          <p class="title">{{ item.title }}</p>
          <div class="margin-top-20px text">
            <p class="icon-text">
              <i class="iconfont icon-renyuan" />
              <span class="margin-right-20px" v-html="item.author" />
            </p>
            <p class="icon-text">
              <i class="iconfont icon-zazhiqikan" />
              <span class="margin-right-20px">{{ item.published }}</span>
            </p>
          </div>
        </div>
      </div>
      <!-- 分页 -->
      <div class="pagination margin-top-20px">
        <el-pagination
          background
          layout="prev, pager, next"
          :page-size="pageSize"
          :total="total"
          @current-change="pageChange"
        />
      </div>
    </section>
    <section class="section">
      <div class="text-center"><h3 class="fs-36 text-decoration section-title">Peer Reviewed Conference Papers</h3></div>
      <div class="list">
        <div v-for="(item, index) in conferenceList" :key="index" class="item">
          <p class="title">{{ item.title }}</p>
          <div class="margin-top-20px text">
            <p class="icon-text">
              <i class="iconfont icon-renyuan" />
              <span class="margin-right-20px" v-html="item.author" />
            </p>
            <p class="icon-text">
              <i class="iconfont icon-zazhiqikan" />
              <span class="margin-right-20px">{{ item.published }}</span>
            </p>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>
<script type="text/javascript">
import SideIcons from '@/components/sideIcons/sideIcons'
import jsData from '@/data/publications.js'
import topMixin from '@/components/sideIcons/topMixin'
export default {
  components: { SideIcons },
  mixins: [topMixin],
  data() {
    return {
      page: 1,
      pageSize: 8,
      journalPageList: []
    }
  },
  computed: {
    total() {
      return this.journalList.length
    },
    conferenceList() {
      return jsData.conference
    },
    journalList() {
      return jsData.journal
    }
  },
  created() {
    this.journalPageList = this.journalList.slice(0, this.pageSize)
  },
  methods: {
    pageChange(val) {
      this.page = val
      this.journalPageList = this.journalList.slice((val - 1) * this.pageSize, val * this.pageSize)
      this.toTop('journal')
    }
  }
}
</script>
<style lang="scss" scoped>
.page {
  .section{
    padding-left: 10%;
    padding-right: 10%;
    padding-bottom: 0;
    &:last-child{
      padding-bottom: 4vw;
    }
  }
  .icon-text{
    display: inline-block;
  }
}

@media screen and (max-width: 760px){
  .list{
    padding: 0;
  }
  .icon-text{
    display: block;
    &:last-child{
      margin-top: 10px;
    }
  }
}
</style>
